export default "__VITE_ASSET__DN640Ywg__"